<template>
  <div class="flex flex-wrap m-4" :class="{ 'mr-8': !isMobile }">
    <div class="header my-4">
      <zt-button
        color="dark-400"
        icon="angle-left"
        text
        class="go-back"
        @click="goBack"
        data-vs-button="workflow-panel-btn-goback"
      >
        {{ $t('message.workflow.goBack') }}
      </zt-button>
      <h2 class="font-normal text-2xl">
        {{ $t('message.workflow.title') }}
      </h2>
    </div>
    <div class="w-full">
      <workflow-request-mobile
        v-if="isMobile"
        :rows="rows"
        :loading="loading"
        @workflow-selected="setWorkflowSelected"
      />
      <workflow-request-desktop
        v-else
        :rows="rows"
        :loading="loading"
        @workflow-selected="setWorkflowSelected"
      />
    </div>
    <document-preview-dialog
      :workflow-selected="workflowSelected"
      :active="showPreviewDialog"
    />
  </div>
</template>
<script>
import Employee from '@/apiClient/Employee'
import DocumentPreviewDialog from '@/modules/Documents/Workflow/components/modals/DocumentPreviewDialog.vue'
import WorkflowRequestMobile from './WorkflowRequestMobile.vue'
import WorkflowRequestDesktop from './WorkflowRequestDesktop.vue'
import { useWindowResize } from '@sichern/ui-elements'

export default {
  name: 'WorkflowRequestList',
  components: {
    DocumentPreviewDialog,
    WorkflowRequestMobile,
    WorkflowRequestDesktop
  },
  provide() {
    return {
      setPreviewDialog: this.setPreviewDialog
    }
  },
  data() {
    return {
      apiEmployee: new Employee(),
      rows: [],
      loading: true,
      showPreviewDialog: false,
      workflowSelected: {},
      windowResize: useWindowResize(this)
    }
  },
  computed: {
    isMobile() {
      return this.windowResize.width < 1024
    }
  },
  created() {
    this.getUserRequestHistory()
  },
  methods: {
    hasHistory() {
      return window.history.length > 2
    },
    goBack() {
      this.hasHistory() ? this.$router.go(-1) : this.$router.push('/')
    },
    async getUserRequestHistory() {
      this.loading = true
      try {
        const {
          data: { data }
        } = await this.apiEmployee.getRequestHistory()
        this.rows = data.map(request => {
          request.created_at = request.created_at.split(' ')[0]
          return request
        })
        this.loading = false
      } catch (e) {
        this.rows = []
        this.loading = false
      }
    },
    setWorkflowSelected(item) {
      this.workflowSelected = item
      this.setPreviewDialog(true)
    },
    setPreviewDialog(active) {
      this.showPreviewDialog = active
      if (!active) this.workflowSelected = {}
    }
  }
}
</script>

<style scoped lang="scss">
h2,
h3 {
  color: #707070;
}
h3 {
  font-size: 1.25rem;
}

::v-deep {
  .zt-button.go-back {
    background: none !important;
    padding: 4px !important;
    font-size: 1rem !important;
    color: #707070;
    margin: 0;
    span:first-child {
      width: 10px;
    }
    span.zt-button-text {
      margin-top: 2px;
    }
  }
}
</style>
